const CURRENT_RATES = {
  BUSDCZK: 22,
}

export class CurrencyOperations {
  static getValueIn(from: string | undefined, to: string, value: number) {
    const rate = CURRENT_RATES[`${from}${to}`]

    return value * rate
  }
}